module.exports = __webpack_public_path__ + "16a29b6e5bc014e248db6ef208057deb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-lake.png
// module id = 2992
// module chunks = 0